import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Packages
import shortid from 'shortid';

// Actions
import {
  showModal,
} from '../../actions/modal';

const socialMediaIcons = {
  facebook: '#facebook',
  hudl: '#hudl',
  instagram: '#instagram',
  twitter: '#twitter',
}

const addHttp = (url) => {
  if (url && !/^(f|ht)tps?:\/\//i.test(url)) {
     url = "http://" + url;
  }

  return url;
}

const SocialMediaLink = ({ name, url }) => {
  if (!url) { return null }

  return (
    <a
      className="icon-link"
      href={addHttp(url)}
      key={shortid.generate()}
      target="_blank"
    >
      <svg className="icon"><use xlinkHref={socialMediaIcons[name]} /></svg>
    </a>
  )
}

const ProfileImageSocialMediaIcons = ({ socialMedia, showModal }) => (
  <div>
    <div className="social-icons">
      {
        socialMedia.map((platform, i) =>
          <SocialMediaLink
            key={i}
            name={platform.name}
            url={platform.url}
          />
        )
      }
      <span
        className="share-button"
        onClick={() => { showModal({
          modalType: 'share-this',
          optionalProps: {
            shareUrl: window.location.href,
            shareHeadingText: 'Share this profile',
            shareText: 'Hey, check out this athlete I found on Locker Linked!',
            helperText: 'Share this profile using your favorite social channels.'
          }
        })}}
      >
        <svg><use xlinkHref="#share"/></svg>
        <span>Share</span>
      </span>
    </div>
  </div>
)

ProfileImageSocialMediaIcons.propTypes = {
  socialMedia: PropTypes.array.isRequired,
  showModal: PropTypes.func
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (modalType) => {
      dispatch(showModal(modalType))
    }
  }
}

export default connect(
  null,
  mapDispatchToProps
)(ProfileImageSocialMediaIcons)



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileImageSocialMediaIcons.js